import { render } from "./RecipientsForm.vue?vue&type=template&id=72fcb2b5&scoped=true"
import script from "./RecipientsForm.vue?vue&type=script&lang=js"
export * from "./RecipientsForm.vue?vue&type=script&lang=js"

import "./RecipientsForm.vue?vue&type=style&index=0&id=72fcb2b5&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fcb2b5"]])

export default __exports__